export default __webpack_public_path__ + "static/media/L_Lampada.7068899e.svg";